import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { generalService } from './general.service';

@Injectable()
export class EditCodeSatService {
  public matOptions: any;
  private matOptionsSubject = new Subject<any>();
  matOptions$ = this.matOptionsSubject.asObservable();

  constructor(private _generalService: generalService) { this.matOptions = new Object();}



  consultSATcode() {
        this._generalService.metodoCall('itemCodeSAT/consultItemSATcodes')
        .subscribe(SATcodes => {
          SATcodes = JSON.parse(SATcodes);
          this.matOptions.SATcodes = SATcodes;
          this.emitMatOptions();
        });

      }

      emitMatOptions(){
        this.matOptionsSubject.next(this.matOptions);
      }
   
   
  }

 





// WEBPACK FOOTER //
// ./src/app/services/edit-code-sat.service.ts